"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    badgeText: '',
    brandName: 'Brand name',
    productName: 'Product name',
    primaryPrice: {
      price: '00',
      signDirection: 'left',
      rateText: '/month'
    },
    secondaryPrice: {
      price: '',
      signDirection: 'left',
      rateText: 'Upfront'
    },
    term: '24 months | 0% APR Bring-it-Back applied',
    buttonLabel: 'Select this phone',
    selectedButtonLabel: 'Selected phone'
  },
  fr: {
    badgeText: '',
    brandName: 'Brand name',
    productName: 'Product name',
    primaryPrice: {
      price: '00',
      signDirection: 'right',
      rateText: '/mois'
    },
    secondaryPrice: {
      price: '',
      signDirection: 'right',
      rateText: "d'acompte"
    },
    term: '24 mois | TAP de 0% | avec Option retour',
    buttonLabel: 'Sélectionner ce téléphone',
    selectedButtonLabel: 'Téléphone sélectionné'
  }
};